import React, { Component } from 'react';
import T from 'prop-types';
// components
import Dropdown, {
  DropdownTrigger,
  DropdownContent,
} from 'react-simple-dropdown';
import { NavLink } from 'react-router-dom';
// styles
import styles from './UserDropdown.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

class UserDropdown extends Component {
  closeDropdown = () => {
    this.refs.dropdown.hide();
  };

  render() {
    const { username, color, isSupport } = this.props;

    return (
      <Dropdown className={styles.dropdown} ref="dropdown">
        <DropdownTrigger className={cx('trigger')}>
          <div
            className={cx('user-avatar')}
            style={{ backgroundColor: color }}
          />
          <span className={styles.username}>{username}</span>
        </DropdownTrigger>
        <DropdownContent
          className={styles['dropdown__content']}
          onClick={this.closeDropdown}
        >
          <NavLink to="/profile">Profile</NavLink>
          <NavLink to="/billing" className={cx({ hide: isSupport })}>
            Billing
          </NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/help" className={cx({ hide: isSupport })}>
            Help
          </NavLink>
          <NavLink to="/logout">Logout</NavLink>
        </DropdownContent>
      </Dropdown>
    );
  }
}

UserDropdown.defaultProps = {
  color: '#33C370',
};

UserDropdown.propTypes = {
  username: T.string.isRequired,
  color: T.string,
  isSupport: T.bool,
};

export default UserDropdown;



// WEBPACK FOOTER //
// ./src/components/UserDropdown/UserDropdown.jsx